import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute } from '@angular/router';
import { ConfigService } from 'src/app/core/service/config.service';
import { CreateComponent } from 'src/app/features/user-managment/component/all-users/create/create.component';
import { Change_MailComponent } from 'src/app/features/user-managment/component/profile/Change_Mail/Change_Mail.component';
import { ChangePasswordComponent } from 'src/app/features/user-managment/component/profile/change-password/change-password.component';
import { PrivacySettingComponent } from 'src/app/features/user-managment/component/profile/privacy-setting/privacy-setting.component';
import { SuspendUnsuspendComponent } from 'src/app/features/user-managment/component/profile/suspend-unsuspend/suspend-unsuspend.component';
import { ApiUserService } from 'src/app/features/user-managment/core/service/api-user.service';
import { MenuService } from 'src/app/layout/adminpanel/menu.service';
import { ConfirmComponent } from '../../actions/delete/confirm.component';
import { ActionsModal } from 'src/app/core/modal/actions/actions-modal';
import { UserInfoService } from '../../services/user-info.service';
import { ProfileModal } from 'src/app/features/user-managment/core/modal/profile-modal';
import { SideNavConfigService } from 'src/app/layout/main-layout/side-nav-config.service';
import { CreateStaffComponent } from 'src/app/features/user-managment/component/list-staff/create-staff/create-staff.component';
import { ChangePhoneComponent } from 'src/app/features/user-managment/component/profile/change-phone/change-phone.component';

@Component({
  selector: 'app-user-info-card',
  templateUrl: './user-info-card.component.html',
  styles: [
  ]
})
export class UserInfoCardComponent {
  @Output() Loading = new EventEmitter<boolean>(true);

  userData: any;

  userID!: string;
  isMyProfile: boolean = false
  authUser: any = localStorage.getItem("auth");

  constructor(
    public _config: ConfigService,
    private _users: ApiUserService,
    private dialog: MatDialog,
    private _activeRoute: ActivatedRoute,
    // private menu: MenuService,
    private _sideNavService: SideNavConfigService,
    private _userInfoService: UserInfoService
  ) {
    this.userID = this._activeRoute.snapshot.params['id'] ? this._activeRoute.snapshot.params['id'] : JSON.parse(this.authUser)?.user?.id;

  }
  ngOnInit(): void {
    //Called after the constructor, initializing input properties, and the first call to ngOnChanges.
    //Add 'implements OnInit' to the class.
    this.onGetUser();
    // let x = this._config.getAuthUserInfo();

    if (this._config._router.url == "/admin/profile" || this._config._router.url == "/myProfile") {
      this.isMyProfile = true
    }
  }

  onEditAccount() {
    if (this.userData?.roles[0]?.role_code == 'General' || this.userData?.roles[0]?.role_code == 'Admin') {
      this.UpdateBidderAccount();
    } else {
      this.UpdateStaffAccount();
    }
  }

  UpdateStaffAccount() {
    const dialogRef = this.dialog.open(CreateStaffComponent, {
      width: "540px",
      panelClass: 'customDialogStyle',
      data: this.userData.id
    })

    dialogRef.afterClosed().subscribe((result: any) => {
      if (result) {
        this.onGetUser();
      }
    })
  }

  UpdateBidderAccount() {
    const updateDialogDetailes: ProfileModal = {
      title: this._config.translate.instant('users.editProfile'),
      buttonText: this._config.translate.instant('forms.UPDATE'),
      user: this.userData,
      type: this._config.getAuthUserInfo().user.role_code == 'General' ? "compelete" : 'update'
    }
    const dialogRef = this.dialog.open(CreateComponent, {
      width: '550px',
      data: updateDialogDetailes,
      panelClass: 'customDialogStyle'
    });

    dialogRef.afterClosed().subscribe((res) => {
      if (res == 'success') {
        this.onGetUser();
      }


    });
  }

  onCompeleteMyProfile() {
    const updateDialogDetailes: ProfileModal = {
      title: "Complete my Profile",
      buttonText: "UPDATE",
      user: this.userData,
      type: 'compelete'
    }
    const dialogRef = this.dialog.open(CreateComponent, {
      width: '550px',
      data: updateDialogDetailes,
      panelClass: 'customDialogStyle'
    });

    dialogRef.afterClosed().subscribe((res) => {
      if (res == 'success') {
        this.onGetUser();
      }
    });
  }

  onChangePassword() {
    // debugger
    const dialogRef = this.dialog.open(ChangePasswordComponent, {
      width: '550px',
      data: { user_id: this.userData?.id, showOldPassword: this.isMyProfile },
      panelClass: 'customDialogStyle'
    });

    dialogRef.afterClosed().subscribe((res) => {
      if (res == 'success') {
        this.onGetUser();
      }


    });
  }

  onGetUser() {

    // this.Loading.emit(true)
    this._users.getUser(this.userID).subscribe({
      next: (data) => {

        this.Loading.emit(false)
        this.userData = data.data;
      }, error: (error) => {

        this.Loading.emit(false)

        this._config.showErrors(error)
      }
    });
  }

  ChangeMail() {
    const dialogRef = this.dialog.open(Change_MailComponent, {
      width: '550px',
      data: this.userData?.id,
      panelClass: 'customDialogStyle'
    });

    dialogRef.afterClosed().subscribe((res) => {
      if (res == 'success') {
        this.onGetUser();
      }
    });
  }

  ChangePhone() {
    const dialogRef = this.dialog.open(ChangePhoneComponent, {
      width: '550px',
      data: this.userData?.id,
      panelClass: 'customDialogStyle'
    });

    dialogRef.afterClosed().subscribe((res) => {
      if (res == 'success') {
        this.onGetUser();
      }
    });
  }



  PrivacySetting() {
    const dialogRef = this.dialog.open(PrivacySettingComponent, {
      width: '550px',
      data: this.userData?.is_anonymous,
      panelClass: 'customDialogStyle'
    });

    dialogRef.afterClosed().subscribe((res) => {
      if (res == 'success') {
        this.onGetUser();
      }


    });
  }

  onViewWallet() {

    // this.menu.ToggleWallet(true)
    this._sideNavService.ChangeSideNav({
      status: true,
      type: 'wallet',
      id: this.userID,
      disableClose: true
    })
  }

  OnSuspendOrUnsuspend() {
    const dialogRef = this.dialog.open(SuspendUnsuspendComponent, {
      width: '550px',
      data: { user: this.userData, isSuspend: true },
      panelClass: 'customDialogStyle'
    });

    dialogRef.afterClosed().subscribe((res) => {
      if (res) {
        this.onGetUser();
      }


    });
  }


  OnDeleteUser() {
    const dataConfirmActions: ActionsModal = {
      title: "Confirm Bidder Delete",
      icon: 'warning',
      text: this._config.translate.instant("actions.confirmTxt"),
      confirm: this._config.translate.instant("actions.confirm"),
      cancel: this._config.translate.instant("actions.cancel"),
    };

    const dialogRef = this.dialog.open(ConfirmComponent, {
      // width: '550px',
      data: dataConfirmActions,
      panelClass: 'customDialogStyle'
    });

    dialogRef.afterClosed().subscribe((res) => {
      if (res == "success") {
        this._users.delete(this.userID).subscribe({
          next: (res) => {
            this._config.toastrService.success(res.message)
            this._config._router.navigate(['/admin/usersManagement/users'])
          },
          error: (err) => {
            this._config.showErrors(err)
          }
        })

      }


    });
  }

  onSelectFile(files: any) {
    if (files.length == 0) {
      return;
    }
    // this.loading = true;
    const formData = new FormData();
    formData.append('image', files[0], files[0].name);
    formData.append('_method', 'PUT');

    this._users.changeProfileImage(this.userID, formData).subscribe({
      next: (data) => {
        this._config.toastrService.success(this._config.translate.instant('users.imageChange'));
        let user = this._config.getAuthUserInfo()
        if (user?.user?.id == data?.data?.id) {
          user.user = data.data
          localStorage.setItem("auth", JSON.stringify(user));
          window.location.reload();
        }

        this.onGetUser()
      }, error: (err) => {
        this._config.showErrors(err)
      }
    })
  }
}
